import { render, staticRenderFns } from "./SampleUploaderEmbed.vue?vue&type=template&id=472d1200"
import script from "./SampleUploaderEmbed.vue?vue&type=script&lang=js"
export * from "./SampleUploaderEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472d1200')) {
      api.createRecord('472d1200', component.options)
    } else {
      api.reload('472d1200', component.options)
    }
    module.hot.accept("./SampleUploaderEmbed.vue?vue&type=template&id=472d1200", function () {
      api.rerender('472d1200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleUploaderEmbed.vue"
export default component.exports